import { render, staticRenderFns } from "./stationDiscountActivity.vue?vue&type=template&id=3c6b08a3&"
import script from "./stationDiscountActivity.vue?vue&type=script&lang=js&"
export * from "./stationDiscountActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6b08a3')) {
      api.createRecord('3c6b08a3', component.options)
    } else {
      api.reload('3c6b08a3', component.options)
    }
    module.hot.accept("./stationDiscountActivity.vue?vue&type=template&id=3c6b08a3&", function () {
      api.rerender('3c6b08a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/stationDiscount/stationDiscountActivity.vue"
export default component.exports